import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter, rupiah, formatTime } from 'utils/formatter';

class ShiftDetailTotalIncome extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapseIncome: false };
  }

  componentWillReceiveProps() {
    this.setState({ collapseIncome: false });
  }

  render() {
    const { shift } = this.props;
    return (
      <div className="row">
        <div className="col-sm-12">
          {shift.total_income <= 0 && (
            <div
              className="form-group col-sm-12 label-section"
              id="collapsibleIncome"
            >
              <div>
                <a className="collapsed disable">
                  <label>TOTAL INCOME</label>
                  <div>Rp. 0</div>
                </a>
              </div>
            </div>
          )}
          {shift.total_income > 0 && (
            <div
              className="form-group col-sm-12 label-section"
              id="collapsibleIncome"
            >
              <div>
                <a
                  className={`${!this.state.collapseIncome ? 'collapsed' : ''}`}
                  onClick={this._onClickCollapseIncomeLink}
                >
                  <label>TOTAL INCOME</label>
                  <div className="">
                    {currencyFormatter(shift.total_income)}
                  </div>
                </a>
              </div>
              {this.state.collapseIncome && (
                <div id="collapseIncome">
                  <ul>
                    {shift.shift_details.map((detail, idx) => {
                      return (
                        detail.type === 'Income' && (
                          <li key={idx}>
                            <div>
                              <label className={`detail-description`}>
                                {formatTime(detail.created_at)} -{' '}
                                {detail.description}
                              </label>
                              <div className={``}>
                                <span className="">
                                  {rupiah(detail.amount)}
                                </span>
                              </div>
                            </div>
                          </li>
                        )
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  _onClickCollapseIncomeLink = () => {
    this.setState({ collapseIncome: !this.state.collapseIncome });
  };
}

ShiftDetailTotalIncome.propTypes = {
  shift: PropTypes.object,
};
export default ShiftDetailTotalIncome;
